import React, { Component } from "react";
import { connect } from "react-redux";
import { getAdminCompanyById } from "../../../../actions/company.actions";
import AdminCompanyProjects from "../components/AdminCompanyProjects";

class AdminCompanyProjectsContainer extends Component {
  componentDidMount() {
    this.props.getAdminCompanyById(this.props.match.params.companyId);
  }

  render() {
    return (
      <AdminCompanyProjects
        projects={this.props.projects}
        id={this.props.match.params.companyId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    projects: state.company.adminCompany.projects
  };
};

const mapDispatchToProps = dispatch => ({
  getAdminCompanyById: companyId => dispatch(getAdminCompanyById(companyId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyProjectsContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyProjectsContainer.js